import React, { useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

const ResetPassword = () => {
    const { token } = useParams();
    const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (formData.password.length < 8) {
            newErrors.password = 'Password must be at least 8 characters';
        }
        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setSuccessMessage(null);
        if (!validateForm()) {
            return;
        }
        setSubmitting(true);
        try {
            await axios.post('/api/v1/user/reset-password', { token, password: formData.password });
            setSuccessMessage('Password updated. You can now sign in.');
        } catch (error) {
            setErrors({ other: error.response?.data?.error || 'An error occurred while resetting the password.' });
        } finally {
            setSubmitting(false);
        }
    };

    if (successMessage) {
        return (
            <div>
                <h2>Reset Password</h2>
                <div className="alert alert-success">{successMessage}</div>
                <Link to="/login"><button className="btn btn-primary">Sign in</button></Link>
            </div>
        );
    }

    return (
        <div>
            <h2>Reset Password</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="password">New password:</label>
                    <input type="password" id="password" name="password" className="form-control" value={formData.password} onChange={handleChange} />
                    {errors.password && <div className="alert alert-danger">{errors.password}</div>}
                </div>
                <div className="mb-2">
                    <label htmlFor="confirmPassword">Confirm password:</label>
                    <input type="password" id="confirmPassword" name="confirmPassword" className="form-control" value={formData.confirmPassword} onChange={handleChange} />
                    {errors.confirmPassword && <div className="alert alert-danger">{errors.confirmPassword}</div>}
                </div>
                {errors.other && <div className="alert alert-danger">{errors.other}</div>}
                <button className="btn btn-primary" type="submit" disabled={submitting}>{submitting ? 'Resetting…' : 'Reset password'}</button>
            </form>
        </div>
    );
};

export default ResetPassword;
